export default {
  MuiFormLabel: {
    root: {
      right: 30,
      left: 'unset',
      '&$focused': {
        right: 20,
        left: 'unset',
      },
      '&$filled': {
        right: 20,
        left: 'unset',
      },
    },
  },
  MuiSelect: {
    iconOutlined: {
      right: 'unset',
      left: 10,
    },
  },
  MuiButton: {
    root: {
      fontWeight: 700,
    },
  },
};
